export function parseHslVar(varName: string): [number, number, number] | null {
  if (typeof window === 'undefined') return null;
  const value = getComputedStyle(document.documentElement).getPropertyValue(`--${varName}`).trim();
  const match = /^(\d+(?:\.\d+)?)\s+(\d+(?:\.\d+)?)%\s+(\d+(?:\.\d+)?)%$/.exec(value);
  if (!match) return null;
  return [
    parseFloat(match[1] ?? '0'),
    parseFloat(match[2] ?? '0') / 100,
    parseFloat(match[3] ?? '0') / 100,
  ];
}

export function hslToRgb(h: number, s: number, l: number): [number, number, number] {
  const c = (1 - Math.abs(2 * l - 1)) * s;
  const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
  const m = l - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;
  if (h < 60) [r, g, b] = [c, x, 0];
  else if (h < 120) [r, g, b] = [x, c, 0];
  else if (h < 180) [r, g, b] = [0, c, x];
  else if (h < 240) [r, g, b] = [0, x, c];
  else if (h < 300) [r, g, b] = [x, 0, c];
  else [r, g, b] = [c, 0, x];
  return [(r + m) * 255, (g + m) * 255, (b + m) * 255];
}

export function relativeLuminance([r, g, b]: [number, number, number]): number {
  const linearise = (v: number) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * linearise(r) + 0.7152 * linearise(g) + 0.0722 * linearise(b);
}

export function contrastForVar(bgVar: string, fgVar: string): number | null {
  const bgHsl = parseHslVar(bgVar);
  const fgHsl = parseHslVar(fgVar);
  if (!bgHsl || !fgHsl) return null;
  const bgLum = relativeLuminance(hslToRgb(...bgHsl));
  const fgLum = relativeLuminance(hslToRgb(...fgHsl));
  const [hi, lo] = bgLum > fgLum ? [bgLum, fgLum] : [fgLum, bgLum];
  return (hi + 0.05) / (lo + 0.05);
}
